export enum UnitSystem {
  Conventional = 1,
  SI = 2
}
